import {  useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import "../styling/sidebar.css";
import { ReactComponent as NextArrow } from "../assets/nextArrow.svg";

export default function SuggestionPop({ closeModal }) {
   const [addsugestion,setAddsugestion] = useState("");

  return (
    <Form>
      <Form.Group controlId="friendEmail" className="form-group">
        <Form.Label className="control-label">Add suggestion</Form.Label>
        <Form.Control
          type="name"
          autoComplete="off"
          placeholder="Add Suggestion"
          value={addsugestion}
          onChange={(e)=>setAddsugestion(e.target.value)}
        />
      </Form.Group>

      <Button size="sm" type="submit" className="friend-refer-submitbtn">
        <div className="d-flex justify-content-between align-items-center text-center">
        <span className="pt-1">Submit</span>
       <NextArrow  /> 
        </div>    
      </Button>
    </Form>
  );
}
